<div class="dashboard-heading">
  <h1>{{ 'ADMIN_PANEL_SERVICES_CATEGORIES' | translate }}</h1>

  <div>
    <dx-button text="{{ 'SYNC_CATALOG' | translate }}" icon="mdi mdi-sync" class="btn btn-green" (onClick)="this.sync()"></dx-button>
  </div>
</div>

<dx-data-grid
  class="datagrid-admin mb-5"
  [dataSource]="this.categories"
  [showBorders]="true"
  [allowColumnResizing]="true"
  [columnMinWidth]="70"
  [columnAutoWidth]="true"
  [masterDetail]="{ enabled: true, template: 'details' }"
  [hoverStateEnabled]="true"
  keyExpr="id"
  stylingMode="outlined"
  rowTemplate="rowTemplate"
  noDataText="{{ 'DATA_NOT_FOUND' | translate }}"
  (onRowClick)="rowClick($event)">
  <!--<dxo-group-panel [visible]="true"></dxo-group-panel>-->
  <!--<dxo-grouping [autoExpandAll]="true"></dxo-grouping>-->

  <dxo-selection mode="single"></dxo-selection>
  <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>

  <dxi-column dataField="code" caption="{{ 'SERVICES_CATEGORIES_ID' | translate }}" cssClass="border-right"></dxi-column>
  <dxi-column
    [dataField]="this.isLanguageUa ? 'nameUa' : 'nameRu'"
    caption="{{ 'SERVICES_CATEGORIES_NAME' | translate }}"
    cssClass="border-right"></dxi-column>
  <dxi-column
    [dataField]="this.isLanguageUa ? 'webNameUa' : 'webNameRu'"
    caption="{{ 'SERVICES_CATEGORIES_NAME_WEB' | translate }}"
    cssClass="border-right"></dxi-column>

  <dxi-column
    dataField="masterCategoryId"
    caption="{{ 'SERVICES_MASTER_CATEGORIES_ID' | translate }}"
    cssClass="ps-3 border-right"></dxi-column>
  <dxi-column
    [dataField]="this.isLanguageUa ? 'masterCategory.nameUa' : 'masterCategory.nameRu'"
    caption="{{ 'SERVICES_MASTER_CATEGORIES_NAME' | translate }}"
    cssClass="border-right"></dxi-column>

  <dxi-column dataField="priority" caption="{{ 'PRIORITY' | translate }}" cssClass="text-center border-right"></dxi-column>

  <dxi-column caption="{{ 'ICON' | translate }}" cssClass="cell-center border-right"></dxi-column>
  <dxi-column name="iconUpload" type="buttons" caption="{{ 'ICON_UPLOAD' | translate }}" cssClass="border-right"></dxi-column>
  <dxi-column name="iconDelete" type="buttons" caption="{{ 'ICON_DELETE' | translate }}"></dxi-column>

  <tbody class="dx-row" *dxTemplate="let entity of 'rowTemplate'">
    <tr class="main-row">
      <td>
        @if (entity.isExpanded) {
          <span><i class="mdi mdi-minus mdi-18px"></i></span>
        }
        @if (!entity.isExpanded) {
          <span><i class="mdi mdi-plus mdi-18px"></i></span>
        }
      </td>
      <td class="border-right">
        {{ entity.data.code }}
      </td>
      <td class="border-right">
        {{ this.isLanguageUa ? entity.data.nameUa : entity.data.nameRu }}
      </td>
      <td class="border-right">
        {{ this.isLanguageUa ? entity.data.webNameUa : entity.data.webNameRu }}
      </td>
      <td class="ps-3 border-right">
        {{ entity.data.masterCategory?.id }}
      </td>
      <td class="border-right">
        {{ this.isLanguageUa ? entity.data.masterCategory.nameUa : entity.data.masterCategory.nameRu }}
      </td>
      <td class="text-center border-right">
        {{ entity.data.priority }}
        <dx-button icon="mdi mdi-arrow-up-bold" class="btn-icon color-green" (onClick)="this.upPriority($event, entity)"></dx-button>
        <dx-button icon="mdi mdi-arrow-down-bold" class="btn-icon color-red" (onClick)="this.downPriority($event, entity)"></dx-button>
      </td>
      <td class="text-center border-right">
        <div class="icon">
          @if (entity.data.iconBody) {
            <img
              [src]="this.sanitizer.bypassSecurityTrustResourceUrl('data:' + entity.data.iconType + ';base64,' + entity.data.iconBody)" />
          }
        </div>
      </td>
      <td class="text-center border-right">
        <dx-button (onClick)="this.uploadIcon($event, entity)" icon="mdi mdi-upload" class="btn-icon color-green"></dx-button>
      </td>
      <td class="text-center">
        <dx-button (onClick)="this.deleteIcon($event, entity)" icon="mdi mdi-close-circle" class="btn-icon color-red"></dx-button>
      </td>
    </tr>
  </tbody>

  <div *dxTemplate="let entity of 'details'">
    <app-service-catalog-categories-details
      [category]="entity.data"
      (onSave)="this.onSave($event)"></app-service-catalog-categories-details>
  </div>

  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 50, 100, 1000]"></dxo-pager>
</dx-data-grid>

<dialog-edit-icon></dialog-edit-icon>
<dialog-update-category></dialog-update-category>
